// extracted by mini-css-extract-plugin
export default {"hide":"hide--gW0Gb","bg":"bg--ZDI9J","adver-container":"adver-container--ewI2C"};